import React, { useEffect, useState } from "react";
import Aos from "aos";
import ImageInfo from "../../../components/client/actions/ImageInfo";
import { useSelector } from "react-redux";
import VideoInfo from "../../../components/client/actions/VideoInfo";

const Cases = () => {
  const [imageInfo, setImageInfo] = useState(false);
  const [videoInfo, setVideoInfo] = useState(false);

  const handleShowImages = () => {
    setImageInfo(true);
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <section className="cases">
        <div
          className="head-title"
          data-aos="fade-down"
          data-aos-duration="1000"
        >
          <span>الحالات المرضيـــة</span>
        </div>
        <div className="boxes">
          <div
            className="box"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-delay="300"
            onClick={() => handleShowImages()}
          >
            <div className="icon">
              <lord-icon
                src="https://cdn.lordicon.com/vneufqmz.json"
                trigger="hover"
                colors="primary:#413634,secondary:#242424,tertiary:#d59f80,quaternary:#d59f80,quinary:#646e78,senary:#f24c00"
                target=".service-d"
                style={{ width: "100%", height: "100%" }}
              ></lord-icon>
            </div>
            <div className="title">صــور للحالات المرضية</div>
          </div>
          <div
            className="box"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-delay="600"
            onClick={() => setVideoInfo(true)}
          >
            <div className="icon">
              <lord-icon
                src="https://cdn.lordicon.com/jccaxoxb.json"
                trigger="hover"
                colors="primary:#848484,secondary:#413634,tertiary:#d59f80"
                target=".service-d"
                style={{ width: "100%", height: "100%" }}
              ></lord-icon>
            </div>
            <div className="title">فيديوهات للحالات المرضية</div>
          </div>
        </div>
      </section>
      <VideoInfo videoInfo={videoInfo} setVideoInfo={setVideoInfo} />
      <ImageInfo imageInfo={imageInfo} setImageInfo={setImageInfo} />
    </>
  );
};

export default Cases;
